import { Outlet } from 'react-router-dom';
import { LayoutProps } from './layout-types';

const MinimalLayout = (props: LayoutProps) => {
  return (
    <div className="min-h-screen bg-stone py-6 flex flex-col justify-center text-center relative overflow-hidden sm:py-12">
      <Outlet />
    </div>
  );
};

export default MinimalLayout;
